(function(){
  const ATTR   = 'adc_enable';
  const SS_KEY = 'adc_enable_pref'; // session only

  const $  = (sel, root=document) => root.querySelector(sel);
  const $$ = (sel, root=document) => Array.from(root.querySelectorAll(sel));

  function setCartAttr(val){
    fetch('/cart/update.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      credentials:'same-origin',
      body: JSON.stringify({ attributes: { [ATTR]: val ? 'true' : 'false' } })
    }).catch(()=>{});
  }

  function setPref(val){ sessionStorage.setItem(SS_KEY, val ? 'true' : 'false'); }
  function getPref(){
    const v = sessionStorage.getItem(SS_KEY);
    return v === 'true' ? true : v === 'false' ? false : true; // default ON
  }

  // Sync one opt-in block’s UI
  function syncBlock(root, val){
    const native = $('.js-adc-enable', root);
    const click  = $('.adc_click_area', root);
    const toggle = $('.adc_toggle', root);
    const applied= $('.adc_applied', root);

    // hidden native checkbox state (no event)
    if (native) native.checked = !!val;

    // custom toggle visuals + a11y
    if (click) click.setAttribute('aria-checked', val ? 'true' : 'false');
    if (toggle) toggle.classList.toggle('is-on', !!val);
    if (applied) applied.style.visibility = val ? 'visible' : 'hidden';
  }

  // Sync all blocks
  function syncAll(val){ $$('.adc_optin').forEach(b => syncBlock(b, val)); }

  // Apply state globally
  function apply(val){
    setPref(val);
    syncAll(val);
    setCartAttr(val);
  }

  // Init (default OFF for this session)
  function init(){
    const current = getPref();
    syncAll(current);
    setCartAttr(current);
  }

  // Delegated handlers
  document.addEventListener('click', function(e){
    const area = e.target.closest('.adc_click_area');
    if (!area) return;
    const root = area.closest('.adc_optin');
    const now  = area.getAttribute('aria-checked') === 'true';
    const next = !now;
    apply(next);
  }, true);

  document.addEventListener('keydown', function(e){
    const area = e.target.closest?.('.adc_click_area');
    if (!area) return;
    if (e.key !== ' ' && e.key !== 'Enter') return;
    e.preventDefault();
    const now  = area.getAttribute('aria-checked') === 'true';
    apply(!now);
  }, true);

  // If anything toggles the hidden native input, honor it
  document.addEventListener('change', function(e){
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    if (!el.classList.contains('js-adc-enable')) return;
    apply(el.checked);
  }, true);

  // If theme re-renders the block, re-sync
  document.addEventListener('cart:rendered', function(){ syncAll(getPref()); });

  // Kick off
  document.addEventListener('DOMContentLoaded', init);
})();